import React from 'react';
import { Check, Gift } from 'lucide-react';
import { BonusCard } from './BonusCard';
import { bonuses } from '../data/bonuses';
import { bonusTableRows } from '../data/offer';
export function BonusSection() {
  return <section className="py-24 px-4 bg-navy" data-id="element-59" data-mp="22elm0ulx3nlg">
      <div className="max-w-6xl mx-auto" data-id="element-60" data-mp="22dagoqctq7s8">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-61" data-mp="1ydrulr99nqnt">
          <p className="inline-flex items-center gap-2 text-seafoam font-bold mb-3" data-id="element-62" data-mp="1aogtg8o07u95">
            <Gift size={18} aria-hidden="true" data-id="element-63" data-mp="1amcnll6jol68" /> Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-extrabold text-white mb-5" data-id="element-64" data-mp="15r740t0m7ilb">
            The 5 Strategic Bonuses
          </h2>
          <p className="text-lg text-white/80" data-id="element-65" data-mp="1epiv0w5e8iea">
            The six volumes give you the complete coaching system. The bonuses give you
            additional tools for the real situations that happen every week.
          </p>
        </div>

        <div className="space-y-8 mb-16" data-id="element-66" data-mp="myd0cv8fzcwe">
          {bonuses.map(bonus => <BonusCard key={bonus.id} bonus={bonus} data-id="element-67" data-mp="29r1s7cb9x6ui" />)}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 max-w-2xl mx-auto" data-id="element-68" data-mp="2eqo0d7c8vwwg">
          <h3 className="text-2xl font-display font-extrabold text-navy text-center mb-6" data-id="element-69" data-mp="2jhwbq8x4xsc9">
            Your 5 Strategic Bonuses
          </h3>
          <div className="overflow-hidden rounded-xl border border-line" data-id="element-70" data-mp="2ofxxx2puy7ry">
            <table className="w-full text-left" data-id="element-71" data-mp="1qtqq7jy9bzbd">
              <thead className="bg-forest text-white text-sm" data-id="element-72" data-mp="1qv1tzjrpd72h">
                <tr data-id="element-73" data-mp="1vtd47vlwtjl8">
                  <th scope="col" className="px-4 py-3 font-bold" data-id="element-74" data-mp="1vstwf7pz4bkx">Bonus</th>
                  <th scope="col" className="px-4 py-3 font-bold text-right whitespace-nowrap" data-id="element-75" data-mp="20qdbg9uhwsdx">
                    Included Today
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-76" data-mp="3c7d0mwljqr3q">
                {bonusTableRows.map(row => <tr key={row} className="border-t border-line" data-id="element-77" data-mp="3h5ek3imvwsfq">
                    <td className="px-4 py-3 text-sm text-ink" data-id="element-78" data-mp="3h3tsa0ryfnlk">{row}</td>
                    <td className="px-4 py-3 text-sm text-right" data-id="element-79" data-mp="1h23wpjvgnrbw">
                      <span className="inline-flex items-center gap-1 font-bold text-forest" data-id="element-80" data-mp="1c4tzhi1tybdi">
                        <Check size={14} strokeWidth={3} className="text-seafoam-dark" aria-hidden="true" data-id="element-81" data-mp="1q3tncnhiqm8m" />
                        FREE
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="text-center mt-6 font-display font-extrabold text-lg text-navy" data-id="element-82" data-mp="tdt391s3gtxn">
            ALL <span className="text-orange" data-id="element-83" data-mp="tbzv1i1u21nj">5</span> INCLUDED AT NO EXTRA COST
          </p>
        </div>
      </div>
    </section>;
}